angular.module('unergie.main')
.factory('DynamicScriptLoaderService', () => {
    const load = (scriptsToLoad) => {
        if (!scriptsToLoad) {
            return
        }

        _.each(_.castArray(scriptsToLoad), (src) => {
            const script = document.createElement('script')

            script.type = 'text/javascript'
            script.src = src

            // Handle IE
            if (script.readyState) {
                script.onreadystatechange = () => {
                    if (script.readyState === 'loaded' || script.readyState === 'complete') {
                        script.onreadystatechange = null
                    }
                }
            }

            script.onerror = (err) => {
                throw new Error(`Failed to load ${src}`)
            }

            document.querySelector('head').appendChild(script)
        })
    }

    return {
        load,
    }
})
